import * as angular from "angular";
import * as _ from "lodash";
import AddCommodityName, { openAddCommodity } from "./addCommodity.controller";
import UpdateCommodityName, { openUpdateCommodity } from "./updateCommodity.controller";
import UpdateCommodityPercentage, { openUpdateCommodityPercentage } from "./updateCommodityPercentage.controller";
import { States } from "../../shared/config/constant.module";
import template from './commodities.tpl.html';
import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import CommoditiesServiceName, { CommoditiesService } from "../../services/batches/commodities.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";

let requires = [AddCommodityName, UpdateCommodityName,UpdateCommodityPercentage, LoaderServiceName, NotifyServiceName, CommoditiesServiceName,
  AuthDataServiceName, UIUtilityServiceName, NavigationServiceName];

interface CommoditiesController {
  commodities: apsViewModels.CommodityItem[];
  commoditypercentages: apsViewModels.CommodityPercentageItem[];
  plants: Plant[];
  selectedPlant: Plant;
  plantChanged(): void;
  add(): void;
  edit(instance: apsViewModels.CommodityItem): void;
  remove(instance: apsViewModels.CommodityItem): void;
}

class CommoditiesCtrl implements CommoditiesController {
  commodities: apsViewModels.CommodityItem[];
  commoditypercentages: apsViewModels.CommodityPercentageItem[];
  plants: Plant[];
  selectedPlant: Plant;

  private loaderService: LoaderService;
  private navigationService: NavigationService;
  private commoditiesService: CommoditiesService;
  private uiUtilityService: UIUtilityService;
  private notifyService: NotifyService;
  private $modal: mm.foundation.modal;
  private $q: angular.IQService;

  constructor(
    loaderService: LoaderService,
    commoditiesService: CommoditiesService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    uiUtilityService: UIUtilityService,
    notifyService: NotifyService,
    $modal: mm.foundation.modal,
    $q: angular.IQService
  ) {
    this.loaderService = loaderService;
    this.navigationService = navigationService;
    this.commoditiesService = commoditiesService;
    this.uiUtilityService = uiUtilityService;
    this.notifyService = notifyService;
    this.$modal = $modal;
    this.$q = $q;

    let promise = this.navigationService.getNavigation().then(nav => {
      this.plants = nav.plants();

      if (nav.selectedPlant && _.includes(this.plants, nav.selectedPlant)) {
        this.selectedPlant = nav.selectedPlant;
      } else {
        this.selectedPlant = _.first(this.plants);
      }

      return this.plantChanged();
    });

    this.loaderService.loadingPromise(promise);
  }

  private loadCommodities(): angular.IPromise<any> {
    return this.commoditiesService
      .get(this.selectedPlant.id)
      .then(commodities => {
        this.commodities = commodities;
      });
  }

  private loadCommodityPercentages(): angular.IPromise<any> {
    return this.commoditiesService
      .getCommodityPercentages(this.selectedPlant.id)
      .then(percentages => {
        this.commoditypercentages = percentages;
      });
  }
  getCommodityName(commodityId: string): string {
    var commodity = this.commodities.filter(x=>x.id==commodityId);
    if(commodity)
      return commodity[0].name;
    return '';
  }
  plantChanged(): void {
    let promises = [];
    promises.push(this.loadCommodities());
    promises.push(this.loadCommodityPercentages());
    this.loaderService.loadingPromise(this.$q.all(promises));
  }

  add(): void {
    let result = openAddCommodity({
      plant: this.selectedPlant,
      allCommodities: this.commodities
    }, this.$modal);

    result.then(instance => {
      if (!instance) {
        return;
      }

      this.commodities.push(instance);
    });
  }

  edit(instance: apsViewModels.CommodityItem): void {
    let result = openUpdateCommodity({
      instance: instance,
      allCommodities: this.commodities
    }, this.$modal);

    result.then(updated => { 
      if (!updated) {
        return;
      }

      _.remove(this.commodities, instance);
      this.commodities.push(updated);
    })
  }

  editPercentage(instance: apsViewModels.CommodityPercentageItem): void {
    let result = openUpdateCommodityPercentage({
      instance: instance,
      allCommodities: this.commodities
    }, this.$modal);

    result.then(updated => {
      if (!updated) {
        return;
      }

      _.remove(this.commoditypercentages, instance);
      this.commoditypercentages.push(updated);
    })
  }
  remove(instance: apsViewModels.CommodityItem): void {
    this.uiUtilityService.confirm('Are you sure you want to delete this commodity?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      this.loaderService.loadingPromise(this.commoditiesService.remove({
        id: instance.id,
        plantId: this.selectedPlant.id
      }).then(() => {
        _.remove(this.commodities, instance);
      }, this.notifyService.handleApiErrors));
    });
  }
  removePercentage(instance: apsViewModels.CommodityPercentageItem): void {
    this.uiUtilityService.confirm('Are you sure you want to delete this commodity percentage?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      this.loaderService.loadingPromise(this.commoditiesService.removeCommodityPercentage({
        id: instance.id,
        plantId: this.selectedPlant.id
      }).then(() => {
        _.remove(this.commoditypercentages, instance);
      }, this.notifyService.handleApiErrors));
    });
  }
}

export default angular.module('aps.controller.commodities', requires)
  .config(($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state({
      name: States.COMMODITIES,
      url: '/admin/commodities',
      controller: 'CommoditiesCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Commodities',
        authorizePlantAdmin: true
      }
    });
  })
  .controller('CommoditiesCtrl', CommoditiesCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/commodities.controller.ts